import React, { useState, useEffect, useContext } from "react";
import {
  Dimensions,
  PixelRatio,
  StyleSheet,
  Text,
  TouchableOpacity,
  View,
  ActivityIndicator,
  Platform,
  Modal,
  ScrollView,
} from "react-native";
import { SafeAreaView } from "react-native-safe-area-context";
import { MaterialCommunityIcons } from "@expo/vector-icons";
import Colours from "../../utils/Colours";
import TopHeaderComponent from "../aTopHeader/TopHeaderComponent";

import { useNavigation, useRoute } from "@react-navigation/native";
import axios, { axiosWithCredentials } from "../../api/axios";
import AppContext from "../../context/AppContext";
import ErrorAlertComp from "../../alertComp/ErrorAlertComp";
import SuccessAlertComp from "../../alertComp/SuccessAlertComp";
import { useWebSafeArea } from "../../hooks/useWebHeights";
import useAxiosPrivate from "../../hooks/useAxiosPrivate";
import useAuth from "../../hooks/useAuth";

const { width, height } = Dimensions.get("window");

// --- RESPONSIVE TOOLKIT ---
const BASE_WIDTH = 375;
const BASE_HEIGHT = 812;

const dynamicFontSize = (size) => {
  const scaleFactor = Math.min(width / BASE_WIDTH, height / BASE_HEIGHT);
  return Math.round(PixelRatio.roundToNearestPixel(size * scaleFactor));
};

const dynamicSpacing = (size) => (width / BASE_WIDTH) * size;
const dynamicSize = (size) => (width / BASE_WIDTH) * size;

const AnonymousOnboardingOTP = () => {
  const webSafeArea = useWebSafeArea();

  const {
    setAuth,
    setActivitySettings,
    // userToken,

    // reverifyUser,
  } = useContext(AppContext);
  const navigation = useNavigation();
  const route = useRoute();
  // const { whatsappNumber, payload } = route.params;
  const { whatsappNumber, mode, tableId } = route.params;
  const { sub } = useAuth();

  //   const { selectedBrandData } = route.params;

  // const { whatsappNumber } = route?.params || { whatsappNumber: "080XXXXXXXX" };
  const [isErrorCompVisible, setIsErrorCompVisible] = useState(false);
  const [isSuccessCompVisible, setIsSuccessCompVisible] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [successMessage, setSuccessMessage] = useState("");
  const [brandName, setBrandName] = useState("");
  const [tablesData, setTableData] = useState();
  const [code, setCode] = useState("");
  const [loading, setLoading] = useState(false);
  const [timer, setTimer] = useState(59);

  const axiosPrivate = useAxiosPrivate();

  // Countdown timer logic for Resend
  useEffect(() => {
    //console.log("Whatsapp", whatsappNumber, tableId, mode);
    const interval = setInterval(() => {
      setTimer((prev) => (prev > 0 ? prev - 1 : 0));
    }, 1000);
    return () => clearInterval(interval);
  }, []);

  const handleKeyPress = (val) => {
    if (code.length < 4) {
      const newCode = code + val;
      setCode(newCode);
      if (newCode.length === 4) {
        verifyOTP(newCode);
      }
    }
  };

  const handleBackNavigation = () => {
    const isLoggedIn = !!sub; // Check if user has a token
    const isWeb = Platform.OS === "web";

    //console.log("here");
    //console.log("isLoggedIn", isLoggedIn);

    if (isWeb && !isLoggedIn) {
      // If on Web and NOT logged in, go to the public Company Home
      // Use navigation.navigate or window.location for a hard reset
      navigation.navigate("getStarted");
    } else {
      // Otherwise, just go back normally
      navigation.navigate("main");
    }
  };

  useEffect(() => {
    //console.log("tablesData", tablesData);
    //console.log("brandName", brandName);
    // //console.log("tablesData.tableName", tablesData.tableName);
    // //console.log("tablesData.associatedBrand.brandName", tablesData.associatedBrand.brandName);
    // //console.log("tablesData.minimumSpend", tablesData.minimumSpend);
  }, [tablesData, brandName]);

  const handleProceedToPayment = () => {
    if (mode == "userSearch") {
      //used for login
      //console.log("moving to usersearch");
    } else {
      navigation.navigate("payForTable", {
        mode: "initial",
        tableId: tablesData._id,
      });
    }
  };

  const handleDelete = () => {
    setCode(code.slice(0, -1));
  };

  // const verifyOTP = (finalCode) => {
  //   setLoading(true);
  //   //console.log("Verifying OTP:", finalCode);
  //   // Logic: Call your API, on success navigate to Payment/Home
  //   setTimeout(() => {
  //     setLoading(false);
  //     // navigation.navigate('SuccessScreen');
  //   }, 2000);
  // };

  const verifyOTP = async (finalCode) => {
    setLoading(true);

    // 1. Extract the data passed from the previous screen
    // const { phone, tableName, spendTier, tableAnonymity } = route.params;

    // 2. Build the payload
    const payload = {
      phone: whatsappNumber, // From navigation params
      code: finalCode, // From the OTP input
    };

    try {
      //console.log("Pushing Onboarding Payload:", payload);
      try {
        if (mode === "userSearch") {
          //during log in check
          //console.log("verification via usersearch");
          const response = await axios.post("/verifyGuest/verifyGuest", payload);
          if (response.status === 200) {
            const { username, profilePicture, phoneNumber } = response.data;
            //console.log("Respones.Dataff", response.data);
            //console.log("Names", username, profilePicture, phoneNumber);
            const userstats = response.data;
            navigation.navigate("personalDetails", { phone: phoneNumber, userstats });
            // navigation.navigate("sign_up", { userstats });
          }

          //using this now
        } else if (mode === "fromOrder") {
          const response = await axios.post("/verifyGuest/verifyGuest", payload);
          //console.log("HEREREWRER", mode);
          if (response.status === 200) {
            //console.log("hwyss");
            if (route.params?.shouldAutoPlaceOrder) {
              //console.log("hwyssgg");

              // navigation.navigate("brandMenu", {
              //   orderVerifiedAuthSuccess: true, // This triggers the useEffect loop above!
              //   // tableId: tableId,
              // });
              // Instead of navigation.navigate with params
              route.params?.onVerifySuccess?.(); // fire the callback
              navigation.goBack(); // then just go back
            } else {
              navigation.navigate("main");
            }
          }
        } else if (mode === "createTable" || mode === "preShow") {
          // const response = await axios.post("/verifyGuest/verifyGuest", payload);
          const response = await axiosWithCredentials.post("/verifyGuest/verifyGuest", payload);

          if (response.status === 200 || response.data.status === "success") {
            const { accessToken, user } = response.data;

            // 1. Save the token to your storage/auth context so the app knows they are logged in
            // (Replace 'setAuth' or storage method with whatever your app uses for authentication)
            setAuth({
              accessToken: accessToken,
              // user: user,
              isProfileComplete: true,
              //isGuest: user.isGuest,
            });

            // Optional: Save token locally via AsyncStorage or SecureStore if your app uses it
            // await AsyncStorage.setItem("userToken", accessToken);

            // 2. Return back to the exact screen they came from
            navigation.goBack();
          }
        }

        // else if (mode === "joinTableOTP") {
        //   const response = await axiosPrivate.post("/joinVirtualTable/joinVirtualTable", payload);
        //   if (response.data.success) {
        //     // Navigates securely to home dashboard viewport or active split-bill layout
        //     navigation.navigate("main", {
        //       screen: "home",
        //       params: { activeTableId: tableId },
        //     });
        //   }
        // }
        else {
          // During actual app use
          const response = await axios.post("/verifyAndOnboard/verifyAndOnboard", payload);

          if (response.status === 200) {
            // const { token, tableID } = response.data;
            const { accessToken, tableData, user, brandName } = response.data;

            // 4. Save token (optional but recommended)
            // await AsyncStorage.setItem('userToken', token);

            // setAuthLocalStorage({ refreshToken });
            setAuth({ accessToken });
            // setActivitySettings(activitySettings);
            // setUserToken(refreshToken);
            // setUserInfo(userInfo);

            setBrandName(brandName);
            setTableData(tableData);

            setLoading(false);
            setSuccessMessage("Verification successfull!!!");
            setIsSuccessCompVisible(true);

            // 5. Navigate to the next screen (e.g., Table Dashboard or Payment)
            // navigation.navigate("VirtualTableScreen", { tableID });
            // navigation.navigate("main");
            //handleBackNavigation(true);
            // Add this to check if the state actually changed in this component
            // setTimeout(() => {
            //   // //console.log("Current userToken after update:", userToken);
            // }, 500);
          }
        }
      } catch (error) {
        //console.log("error", error);
        setLoading(false);
        setErrorMessage(
          error.response?.data?.error || "Incorrect code or Verification failed. Please try again.",
        );
        setIsErrorCompVisible(true);
      }
    } catch (error) {
      setLoading(false);
      //console.error("Verification Error:", error.response?.data || error.message);
      setErrorMessage(error.response?.data?.error || "Verification failed. Please try again.");
      setIsErrorCompVisible(true);
      // alert(error.response?.data?.error || "Verification failed. Please try again.");
    }
  };

  const handleChooseYourFlex = () => {
    navigation.navigate("chooseFlex", {
      tableId: tablesData?._id || tablesData?.id,
    });
  };

  const renderCodeBox = (index) => {
    const digit = code[index];
    const isFocused = code.length === index;
    return (
      <View key={index} style={[styles.codeBox, isFocused && styles.codeBoxFocused]}>
        <Text style={styles.codeText}>{digit || ""}</Text>
        {isFocused && <View style={styles.cursor} />}
      </View>
    );
  };

  return (
    <SafeAreaView style={[styles.safeArea, webSafeArea]}>
      {/* <TopHeaderComponent headerText={"Verification"} hideScreen={() => navigation.goBack()} /> */}
      <TopHeaderComponent
        headerText={"Verification"}
        hideScreen={() => {
          if (navigation.canGoBack()) {
            navigation.goBack();
          } else if (mode === "fromOrder") {
            navigation.navigate("brandMenu", {
              tableId: tableId,
            });
          }
        }}
      />
      <ScrollView
        style={{ flex: 1 }}
        contentContainerStyle={styles.scrollWrapper}
        showsVerticalScrollIndicator={false}
      >
        <View style={styles.container}>
          <View style={styles.headerSection}>
            <View style={styles.iconCircle}>
              <MaterialCommunityIcons name="whatsapp" size={dynamicSize(30)} color="white" />
            </View>
            <Text style={styles.title}>Confirm Your Number</Text>
            <Text style={styles.subtitle}>
              Enter the 4-digit code sent to{"\n"}
              <Text style={styles.boldNumber}>{whatsappNumber}</Text>
            </Text>
          </View>

          {/* OTP DISPLAY BOXES */}
          <View style={styles.otpRow}>{[0, 1, 2, 3].map((i) => renderCodeBox(i))}</View>

          {loading ? (
            <ActivityIndicator color={Colours.PRIMARY} style={{ marginTop: 20 }} />
          ) : (
            <TouchableOpacity
              disabled={timer > 0}
              style={styles.resendBtn}
              onPress={() => setTimer(59)}
            >
              <Text style={[styles.resendText, timer > 0 && { color: "#AAA" }]}>
                {timer > 0
                  ? `Resend code in 0:${timer < 10 ? `0${timer}` : timer}`
                  : "Resend Code via WhatsApp"}
              </Text>
            </TouchableOpacity>
          )}

          {/* CUSTOM NUMPAD - CLASSY LOOK */}
          <View style={styles.numpad}>
            {[1, 2, 3, 4, 5, 6, 7, 8, 9].map((num) => (
              <TouchableOpacity
                key={num}
                style={styles.numBtn}
                onPress={() => handleKeyPress(num.toString())}
              >
                <Text style={styles.numBtnText}>{num}</Text>
              </TouchableOpacity>
            ))}
            <View style={styles.numBtnEmpty} />
            <TouchableOpacity style={styles.numBtn} onPress={() => handleKeyPress("0")}>
              <Text style={styles.numBtnText}>0</Text>
            </TouchableOpacity>
            <TouchableOpacity style={styles.numBtn} onPress={handleDelete}>
              <MaterialCommunityIcons
                name="backspace-outline"
                size={dynamicSize(24)}
                color={Colours.DARKGRAY}
              />
            </TouchableOpacity>
          </View>
        </View>
      </ScrollView>

      <Modal visible={isErrorCompVisible} transparent={true} animationType="fade">
        <ErrorAlertComp message={errorMessage} onClose={() => setIsErrorCompVisible(false)} />
      </Modal>
      <Modal visible={isSuccessCompVisible} transparent={true} animationType="fade">
        <SuccessAlertComp
          message={successMessage}
          onClose={() => {
            setIsSuccessCompVisible(false);
            //handleBackNavigation(); // this should move to paystack payments.
            //handleProceedToPayment();
            handleChooseYourFlex();
          }}
        />
      </Modal>
    </SafeAreaView>
  );
};

export default AnonymousOnboardingOTP;

const styles = StyleSheet.create({
  safeArea: {
    flex: 1,
    backgroundColor: "white",
    // ...(Platform.OS === "web" && {
    //   height: "100vh",
    //   overflow: "hidden",
    // }),
  },
  scrollWrapper: {
    padding: dynamicSpacing(5),
    paddingBottom: dynamicSpacing(130),
  },
  container: {
    flex: 1,
    paddingHorizontal: dynamicSpacing(30),
    alignItems: "center",
    justifyContent: "space-between",
    paddingBottom: dynamicSpacing(20),
  },
  headerSection: {
    alignItems: "center",
    marginTop: dynamicSpacing(20),
    marginBottom: dynamicSpacing(40),
  },
  iconCircle: {
    width: dynamicSize(60),
    height: dynamicSize(60),
    borderRadius: 30,
    backgroundColor: "#25D366",
    justifyContent: "center",
    alignItems: "center",
    marginBottom: dynamicSpacing(20),
  },
  title: {
    fontFamily: "Sen-Bold",
    fontSize: dynamicFontSize(22),
    color: Colours.DARKGRAY,
    marginBottom: 10,
  },
  subtitle: {
    fontFamily: "Sen-Regular",
    fontSize: dynamicFontSize(14),
    color: "gray",
    textAlign: "center",
    lineHeight: 22,
  },
  boldNumber: { color: Colours.DARKGRAY, fontFamily: "Sen-Bold" },

  otpRow: {
    flexDirection: "row",
    justifyContent: "space-between",
    width: "100%",
    marginBottom: dynamicSpacing(30),
  },
  codeBox: {
    width: dynamicSize(65),
    height: dynamicSize(75),
    backgroundColor: "#F9F9F9",
    borderRadius: 15,
    borderWidth: 1,
    borderColor: "#EEE",
    justifyContent: "center",
    alignItems: "center",
    position: "relative",
  },
  codeBoxFocused: {
    borderColor: Colours.PRIMARY,
    backgroundColor: "white",
    elevation: 4,
    shadowOpacity: 0.1,
  },
  codeText: { fontFamily: "Sen-Bold", fontSize: dynamicFontSize(28), color: Colours.DARKGRAY },
  cursor: {
    position: "absolute",
    bottom: 15,
    width: 20,
    height: 2,
    backgroundColor: Colours.PRIMARY,
  },

  resendBtn: { marginTop: dynamicSpacing(10) },
  resendText: { fontFamily: "Sen-Bold", fontSize: dynamicFontSize(13), color: Colours.PRIMARY },

  numpad: {
    flexDirection: "row",
    flexWrap: "wrap",
    justifyContent: "space-between",
    width: "100%",
    marginTop: "auto",
    marginBottom: dynamicSpacing(30),
  },
  numBtn: {
    width: "30%",
    height: dynamicSize(70),
    justifyContent: "center",
    alignItems: "center",
    marginBottom: dynamicSpacing(10),
  },
  numBtnEmpty: { width: "30%" },
  numBtnText: { fontFamily: "Sen-Bold", fontSize: dynamicFontSize(24), color: Colours.DARKGRAY },
});
